<template>
  <section class="main-section-wrapper">
    <div class="row mb-3 pt-4">

      <div class="col-12">
        <h2 class="options-title text-center text-md-start">{{ t('psycologists-options.title') }}</h2>
        <p class="module-description text-center text-md-start">{{ t('psycologists-options.based-on-results') }}</p>
      </div>
    </div>

    <!-- psycologists slider -->
    <div class="row">
      <psycologists-slider></psycologists-slider>
    </div>
  </section>

  <register-modal @registerUser="searchPsychologist"></register-modal>
  <informed-consent @accept="acceptConcent"></informed-consent>
</template>

<script>
  import {useI18n} from 'vue-i18n'
  import PsycologistsSlider from '@/modules/psycologists-options/components/Slider.vue'
  import RegisterModal from '@/components/RegisterModal.vue'
  import { onBeforeUnmount, onMounted } from 'vue'
  import { computed } from "vue";
  import { useStore } from "vuex";
  import usePsycologistsOptions from '../composable/usePsycologistsOptions'
  import InformedConsent from '@/components/InformedConsent.vue'

  export default {
    components: {
      PsycologistsSlider,
      RegisterModal,
      InformedConsent
    },
    setup() {
      const { getCatalogs, acceptInformedConsent, psychologistsArray } = usePsycologistsOptions({})
      const store = useStore();
      const token = computed(() => store.getters[`auth/getToken`]);
      const loggedUser = computed(() => store.getters['auth/getLoggedUser']);
      const {t} = useI18n()

      const searchPsychologist = async () => {
        store.commit('psycologistsOptions/clearPsychologist');
        store.commit('setGeneralIsLoading', true);
        await getCatalogs();
        if (psychologistsArray.value.length == 0) {
          store.commit('setPsyMatchesFound', false);
        } else {
          const informedConcentModal = bootstrap.Modal.getOrCreateInstance(document.querySelector('#informedConcent'))
          informedConcentModal.show()
        }

        store.commit('setGeneralIsLoading', false);
      }

      const acceptConcent = async () => {
        const {data, error, message} = await acceptInformedConsent(loggedUser.value.patient_id)

        if (!error) {
          const informedConcentModal = bootstrap.Modal.getOrCreateInstance(document.querySelector('#informedConcent'))
          informedConcentModal.hide()
        }
      }

      onMounted(async () => {
        if (loggedUser.value) {
          store.commit('setGeneralIsLoading', true);
          await getCatalogs();

          if (!loggedUser.value.accept_informed_consent) {
            const informedConcentModal = bootstrap.Modal.getOrCreateInstance(document.querySelector('#informedConcent'))
            informedConcentModal.show()
          }

          store.commit('setGeneralIsLoading', false);
        } else {
          const registerModal = document.querySelector('#registerModal')
          const modal = bootstrap.Modal.getOrCreateInstance(registerModal)
          modal.show()
        }
      })

      onBeforeUnmount(() => {
        const registerModal = document.querySelector('#registerModal')
        const modal = bootstrap.Modal.getOrCreateInstance(registerModal)
        modal.hide()
      })

      return {
        t,
        searchPsychologist,
        acceptConcent,
        loggedUser
      }
    }
  }
</script>

<style scoped>

  .main-section-wrapper {
    max-width: 1920px;
    margin: 0 auto;
  }

  .options-title {
    font-family: var(--mm-font-basier-circle);
    font-size: 20px;
    font-weight: 500;
    color: var(--mm-medium-dark);
  }

  .module-description {
    font-family: var(--mm-font-gt-america-mono);
    font-size: 18px;
    color: var(--mm-surface-two);
    text-transform: uppercase;
  }

  /* Media queries */
  @media (min-width: 576px) {
    .options-title {
      font-size: 28px;
    }
  }

  @media (min-width: 768px) {
    .module-description {
      max-width: 1250px;
    }
  }

  @media (min-width: 992px) {}

  @media (min-width: 1200px) {}

  @media (min-width: 1400px) {}
</style>
